import { useGetFriendlyUrl } from "utils/hooks/useGetFriendlyUrl";
import { host } from "utils/http-service";
import { buildUrl } from "utils/queryParams";

import { useReactQuery } from "components/RemoteData";

export const useGetLoginSsoForm = (appointmentId?: string) => {
  const { friendlyUrl } = useGetFriendlyUrl();

  return useReactQuery(getLoginSsoFormKey(), () =>
    getLoginSsoForm(friendlyUrl, appointmentId)
  );
};

const getLoginSsoForm = (friendlyUrl: string, appointmentId?: string) => {
  return fetch(
    buildUrl(`${host}e-reservation/${friendlyUrl}/log-in-sso/html-form`, {
      appointmentId: appointmentId,
    })
  )
    .then((res) => {
      if (!res.ok) {
        throw new Error(res.statusText);
      }
      return res.text();
    })
    .catch((e) => {
      throw e;
    });
};

const getLoginSsoFormKey = () => {
  return "login-form-sso";
};
